import { ref as s, watch as C } from "vue";
const b = (o, f, {
  onInput: u,
  onValidityChange: i
}) => {
  const a = s(!1), t = s(!1), l = s(!1), c = s(!1), n = s(!1), v = s(0), r = () => {
    if (!a.value)
      return;
    const e = t.value;
    t.value = o.value ? !o.value?.validity?.valid : !1, e !== t.value && i && i(!t.value);
  };
  return C(f, () => {
    c.value = !0, r();
  }), {
    listeners: {
      blur: () => {
        a.value = c.value, r(), t.value || (a.value = !1), l.value = !1;
      },
      compositionend: (e) => {
        n.value && u(e), n.value = !1;
      },
      compositionstart: () => {
        n.value = !0;
      },
      focus: () => {
        l.value = !0;
      },
      input: (e) => {
        if (o.value?.type === "number") {
          const p = e.inputType === "insertText" || e.inputType === "insertFromPaste", m = e.data === "." && v.value === o.value?.value?.length, T = e.data === ",", g = e.inputType === "deleteContentBackward", d = o.value?.value?.lastIndexOf("."), x = o.value?.value?.length ?? 0, y = d !== -1 && d === x - 1;
          if (p && (m || T) || g && y)
            return;
        }
        n.value || u(e);
      },
      mouseup: () => {
        v.value = o.value?.selectionEnd || 0;
      }
    },
    touched: a,
    invalid: t,
    focused: l
  };
};
export {
  b as useNativeInput
};
